import axios from 'axios'
import store from '@/store'
import { ElMessage } from 'element-plus'

// 创建 axios 实例
const service = axios.create({
    baseURL: '/',
    timeout: 50000,
    transformRequest: [(data) => {
        if (data instanceof FormData || data instanceof URLSearchParams) {
            return data;
        }

        return JSON.stringify(data);
    }]
})

// 请求拦截器：区分登录的Basic Auth和普通请求的Bearer token（新增前台frontToken）
service.interceptors.request.use(
    config => {
        // 1. 后台token：Bearer token（原有逻辑不变）
        if (store.state.token && !config.headers.Authorization) {
            config.headers['Authorization'] = `Bearer ${store.state.token}`;
        }

        // 2. 前台token：自定义请求头携带
        if (store.state.frontToken && !config.headers.Authorization) {
            config.headers['Authorization'] = `Bearer ${store.state.frontToken}`;
        }

        // 适配FormData/URLSearchParams的Content-Type
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        } else if (config.data instanceof URLSearchParams) {
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        } else if (!config.headers['Content-Type']) {
            config.headers['Content-Type'] = 'application/json';
        }

        return config
    },
    error => {
        ElMessage.error('请求出错：' + error.message)
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        let errMsg = '';
        if (error.code === 'ECONNABORTED') {
            errMsg = '请求超时，请稍后重试';
            ElMessage.error(errMsg);
        } else if (error.response?.status === 401) {
            errMsg = '认证失败，请重新登录';
            ElMessage.error(errMsg);
            store.commit('SET_TOKEN', '');
            // 如果前台token也需要清空，添加这行
            // store.commit('SET_FRONT_TOKEN', '');
            window.location.href = '/login';
        } else if (error.response.data.code === '500' && error.response.data.msg === "无效state") {
            console.log("这里不报错");
        } else if (error.response.data.msg == "样衣编号已存在,请重新生成后保存") {
            console.log("这里不报错");
        }
        else {
            errMsg = error.response?.data?.msg || '接口响应失败';
            ElMessage.error(errMsg);
        }
        return Promise.reject(error);
    }
)

export default service;